const second = 1;
const minute = 60 * second;
const hour = 60 * minute;
const day = 24 * hour;
const week = 7 * day;
const year = 365 * day;

const Durations = {
  second,
  minute,
  hour,
  day,
  week,
  year,
};

export default Durations;
